import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import {
  MdDashboard,
  MdWeb,
  MdInsertChart,
  MdGroupWork,
  MdPages,
  MdKeyboardArrowDown,
  MdExtension,
  MdChromeReaderMode,
  MdViewList,
  MdAccountCircle,
  MdViewCarousel,
  MdViewDay,
  MdWidgets,
  MdBrush,
  MdFavorite,
  MdHome,
} from 'react-icons/md';
import SourceLink from '../../components/SourceLink';
import logo200Image from '../../assets/img/Bahir_Dar__2_-removebg-preview.png';
import sidebarBgImage from '../../assets/img/sidebar/sidebar-4.jpg';
import bn from '../../utils/bemnames';
import { parseJWT } from '../../utils/jwtUtils';

const bem = bn.create('sidebar');

const sidebarBackground = {
  backgroundImage: `url("${sidebarBgImage}")`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

// Dashboard
const dashboardItems = [
  { to: '/dashboard', name: 'dashboard', exact: true, Icon: MdDashboard },
];
// Nav data
const navItems = [
  { to: '/customers', name: 'customers', exact: false, Icon: MdWeb },
  { to: '/all-agent', name: 'agent', exact: false, Icon: MdInsertChart },
];

const pageContents = [
  { to: '/all-house', name: 'View House', exact: false, Icon: MdAccountCircle },
  { to: '/add-house', name: 'New House', exact: false, Icon: MdViewCarousel },
  {
    to: '/house-category',
    name: 'House Category',
    exact: false,
    Icon: MdViewCarousel,
  },
];

const navComponents = [
  {
    to: '/my-house',
    name: 'View House',
    exact: false,
    Icon: MdChromeReaderMode,
  },
  { to: '/add-house', name: 'New House', exact: false, Icon: MdViewList },
];

const tenantRequest = [
  { to: '/request', name: 'Request', exact: true, Icon: MdGroupWork },
];
const landlordRequestList = [
  { to: '/requests', name: 'Request', exact: true, Icon: MdGroupWork },
];
const favoritesItems = [
  { to: '/favorites', name: 'Favorite', exact: true, Icon: MdFavorite },
];
const feedbackItems = [
  { to: '/view-feedback', name: 'Feedback', exact: false, Icon: MdWeb },
];

const navContents = [
  {
    to: '/charts',
    name: 'Rental Analytics',
    exact: false,
    Icon: MdInsertChart,
  },
  { to: '/house-sales', name: 'House Sales', exact: false, Icon: MdWeb },
];

const newsContents = [
  { to: '/view-news', name: 'All News', exact: false, Icon: MdWidgets },
  { to: '/add-news', name: 'Add News', exact: false, Icon: MdBrush },
];

const Sidebar = () => {
  const [isOpenPages, setIsOpenPages] = useState(false);
  const [isOpenComponents, setIsOpenComponents] = useState(false);
  const [isOpenContents, setIsOpenContents] = useState(false);
  const [isOpenNews, setIsOpenNews] = useState(false);

  const token = JSON.parse(localStorage.getItem('userInfo'));

  const userRole = parseJWT(token?.token);
  const isAdminOrSupperAdmin =
    userRole?.role === 'supperAdmin' || userRole?.role === 'admin';
  const isUser = userRole?.role === 'user';

  return (
    <aside className={bem.b()} data-image={sidebarBgImage}>
      <div className={bem.e('background')} style={sidebarBackground} />
      <div className={bem.e('content')}>
        <Navbar>
          <SourceLink className="navbar-brand d-flex">
            <img
              src={logo200Image}
              width="60"
              height="50"
              className="pr-2"
              alt=""
            />
            <span className="text-white">HOME KEY</span>
          </SourceLink>
        </Navbar>

        <Nav vertical>
          {dashboardItems.map(({ to, name, exact, Icon }, index) => (
            <NavItem key={index} className={bem.e('nav-item')}>
              <BSNavLink
                tag={NavLink}
                to={to}
                exact={exact}
                activeClassName="active"
                className="text-uppercase"
              >
                <Icon className={bem.e('nav-item-icon')} />
                <span>{name}</span>
              </BSNavLink>
            </NavItem>
          ))}
          {isAdminOrSupperAdmin && (
            <>
              {navItems.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    tag={NavLink}
                    to={to}
                    exact={exact}
                    activeClassName="active"
                    className="text-uppercase"
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span>{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}

              {/* Pages Dropdown */}
              <NavItem
                className={bem.e('nav-item')}
                onClick={() => setIsOpenPages(!isOpenPages)}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex">
                    <MdPages className={bem.e('nav-item-icon')} />
                    <span className="text-uppercase">House</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      transform: isOpenPages
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transition: 'transform 0.3s',
                    }}
                  />
                </BSNavLink>
              </NavItem>
              <Collapse isOpen={isOpenPages}>
                {pageContents.map(({ to, name, exact, Icon }, index) => (
                  <NavItem key={index} className={bem.e('nav-item')}>
                    <BSNavLink
                      tag={NavLink}
                      to={to}
                      exact={exact}
                      activeClassName="active"
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span>{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}
              </Collapse>
              {/* tenant request list */}
              {landlordRequestList.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    tag={NavLink}
                    to={to}
                    exact={exact}
                    activeClassName="active"
                    className="text-uppercase"
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span>{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </>
          )}
          {isUser && (
            <>
              {/* My House Dropdown */}
              <NavItem
                className={bem.e('nav-item')}
                onClick={() => setIsOpenComponents(!isOpenComponents)}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex">
                    <MdHome className={bem.e('nav-item-icon')} />
                    <span className="text-uppercase">My House</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      transform: isOpenComponents
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transition: 'transform 0.3s',
                    }}
                  />
                </BSNavLink>
              </NavItem>

              <Collapse isOpen={isOpenComponents}>
                {navComponents.map(({ to, name, exact, Icon }, index) => (
                  <NavItem key={index} className={bem.e('nav-item')}>
                    <BSNavLink
                      tag={NavLink}
                      to={to}
                      exact={exact}
                      activeClassName="active"
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span>{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}
              </Collapse>
              {/* tenant request list */}
              {tenantRequest.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    tag={NavLink}
                    to={to}
                    exact={exact}
                    activeClassName="active"
                    className="text-uppercase"
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span>{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </>
          )}

          {/* favorites */}
          {favoritesItems.map(({ to, name, exact, Icon }, index) => (
            <NavItem key={index} className={bem.e('nav-item')}>
              <BSNavLink
                tag={NavLink}
                to={to}
                exact={exact}
                activeClassName="active"
                className="text-uppercase"
              >
                <Icon className={bem.e('nav-item-icon')} />
                <span>{name}</span>
              </BSNavLink>
            </NavItem>
          ))}
          {isAdminOrSupperAdmin && (
            <>
              {/* Feedback */}
              {feedbackItems.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    tag={NavLink}
                    to={to}
                    exact={exact}
                    activeClassName="active"
                    className="text-uppercase"
                  >
                    <Icon className={bem.e('nav-item-icon')} />
                    <span>{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
              {/* Sales Dropdown */}
              <NavItem
                className={bem.e('nav-item')}
                onClick={() => setIsOpenContents(!isOpenContents)}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex">
                    <MdViewDay className={bem.e('nav-item-icon')} />
                    <span className="text-uppercase">Sales</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      transform: isOpenContents
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transition: 'transform 0.3s',
                    }}
                  />
                </BSNavLink>
              </NavItem>
              <Collapse isOpen={isOpenContents}>
                {navContents.map(({ to, name, exact, Icon }, index) => (
                  <NavItem key={index} className={bem.e('nav-item')}>
                    <BSNavLink
                      tag={NavLink}
                      to={to}
                      exact={exact}
                      activeClassName="active"
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span>{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}
              </Collapse>

              {/* News Dropdown */}
              <NavItem
                className={bem.e('nav-item')}
                onClick={() => setIsOpenNews(!isOpenNews)}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex">
                    <MdWidgets className={bem.e('nav-item-icon')} />
                    <span className="text-uppercase">News</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      transform: isOpenNews ? 'rotate(0deg)' : 'rotate(-90deg)',
                      transition: 'transform 0.3s',
                    }}
                  />
                </BSNavLink>
              </NavItem>
              <Collapse isOpen={isOpenNews}>
                {newsContents.map(({ to, name, exact, Icon }, index) => (
                  <NavItem key={index} className={bem.e('nav-item')}>
                    <BSNavLink
                      tag={NavLink}
                      to={to}
                      exact={exact}
                      activeClassName="active"
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span>{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}
              </Collapse>
            </>
          )}
        </Nav>
      </div>
    </aside>
  );
};

export default Sidebar;
